const forStrings = [
    {
        label: "Gleich",
        value: "=",
        icon: "equal",
    },
    {
        label: "Beginnt Mit",
        value: "be",
        icon: "begin",
    },
    {
        label: "Enthält",
        value: "ie",
        icon: "between",
    },
    {
        label: "Ungleich",
        value: "!=",
        icon: "unequal",
    }
];

const forNumerics = [
    {
        label: "Enthält",
        value: "ie",
        icon: "between-number",
    },
    {
        label: "Gleich",
        value: "=",
        icon: "equal",
    },
    {
        label: "Ungleich",
        value: "!=",
        icon: "unequal",
    },
    {
        label: "Kleiner Als",
        value: "<",
        icon: "less",
    },
    {
        label: "Großer Als",
        value: ">",
        icon: "greater",
    },
    {
        label: "Kleiner oder Gleich",
        value: "=<",
        icon: "less-equal",
    },
    {
        label: "Großer oder Gleich",
        value: "=>",
        icon: "greater-equal",
    },
];

export { forNumerics, forStrings };